// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2kKaz","title":"Info_title__2rXt1","links":"Info_links__2L1l6","link":"Info_link__1jSem","logo":"Info_logo__2NbKY"};